import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface Props {
    text: string;
    variant: "user" | "api";
}

export function SemanticSearchConversationMessage({text, variant}: Props) {
    const textVariant = variant === "user" ? "info_txt_1" : "body_copy_2";

    return (
        <div className={cx(messageWrap, textAlignVariants[variant])}>
            <Text variant={textVariant} className={cx(rawHtmlStyling, messageBase[variant], colorVariants[variant])} dangerouslySetInnerHTML={{__html: text}} />
        </div>
    );
}

// Api response align to left side and user message align to right side
const messageWrap = css({
    display: "flex",
    alignItems: "flex-start"
});

const textAlignVariants = {
    user: css({
        justifyContent: "flex-end"
    }),
    api: css({
        justifyContent: "flex-start"
    })
};

const rawHtmlStyling = css({
    "& ul": {
        pl: 2
    },
    "& li": {
        mb: 1
    }
});

const messageBase = {
    user: css({
        p: 1,
        borderRadius: 2,
        maxWidth: "90%"
    }),
    api: css({
        p: 0,
        maxWidth: "90%"
    })
};

const colorVariants = {
    api: css({
        color: "var(--colors-secondary)",
        background: "transparent"
    }),
    user: css({
        color: "var(--colors-white)",
        background: "var(--colors-gray-800)"
    })
};
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface Props {
    text: string;
    variant: "user" | "api";
}

export function SemanticSearchConversationMessage({text, variant}: Props) {
    const textVariant = variant === "user" ? "info_txt_1" : "body_copy_2";

    return (
        <div className={cx(messageWrap, textAlignVariants[variant])}>
            <Text variant={textVariant} className={cx(rawHtmlStyling, messageBase[variant], colorVariants[variant])} dangerouslySetInnerHTML={{__html: text}} />
        </div>
    );
}

// Api response align to left side and user message align to right side
const messageWrap = css({
    display: "flex",
    alignItems: "flex-start"
});

const textAlignVariants = {
    user: css({
        justifyContent: "flex-end"
    }),
    api: css({
        justifyContent: "flex-start"
    })
};

const rawHtmlStyling = css({
    "& ul": {
        pl: 2
    },
    "& li": {
        mb: 1
    }
});

const messageBase = {
    user: css({
        p: 1,
        borderRadius: 2,
        maxWidth: "90%"
    }),
    api: css({
        p: 0,
        maxWidth: "90%"
    })
};

const colorVariants = {
    api: css({
        color: "var(--colors-secondary)",
        background: "transparent"
    }),
    user: css({
        color: "var(--colors-white)",
        background: "var(--colors-gray-800)"
    })
};
